import httpClient from "@/services/httpClient";
import { server, billing_expense } from "@/services/constants";

export const billing_expense_getAllAdvanceCodeByCompany = (company_id) => {
    return httpClient.get(
        `${billing_expense.billing_expense_url}/${server.ADVANCE_CODE_URL}/getAllByCompany/${company_id}`
    );
};